// Autogenerated file
export const platformNewsItemSectionsEnum = {
    Updates: "Updates",
    FreeModules: "FreeModules",
    PaidModules: "PaidModules",
};
export const platformNewsItemSections = [
    { label: "Обновления", value: "Updates" },
    { label: "Бесплатные модули", value: "FreeModules" },
    { label: "Платные модули", value: "PaidModules" },
];
